var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#68AF3D;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st0",
    d: "M75,82.3C63,82.3,53.1,72,53.1,59.4c0-12.6,9.8-22.9,21.9-22.9c12.1,0,21.9,10.3,21.9,22.9 C96.9,72,87.1,82.3,75,82.3z M75,44.3c-7.7,0-14,6.8-14,15.1c0,8.3,6.3,15.1,14,15.1s14-6.8,14-15.1C89.1,51.1,82.8,44.3,75,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M75,242c-2.2,0-3.9-1.8-3.9-3.9v-66.3c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v66.3 C79,240.2,77.2,242,75,242z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M247.7,242H24.5c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9h223.1c2.2,0,3.9,1.8,3.9,3.9 C251.6,240.2,249.8,242,247.7,242z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M151.3,242c-0.5,0-0.9-0.1-1.4-0.3c-2-0.8-3.1-3-2.3-5.1l33.2-87.8c0.8-2,3-3.1,5.1-2.3 c2,0.8,3.1,3,2.3,5.1L155,239.5C154.4,241,152.9,242,151.3,242z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M217.8,242c-1.6,0-3.1-1-3.7-2.5l-25.6-67.7v66.3c0,2.2-1.8,3.9-3.9,3.9 c-2.2,0-3.9-1.8-3.9-3.9v-87.8c0-1.9,1.4-3.5,3.2-3.9c1.8-0.3,3.7,0.7,4.4,2.5l33.2,87.8c0.8,2-0.3,4.3-2.3,5.1 C218.7,241.9,218.3,242,217.8,242z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M139.6,132.9c-1.3,0-2.6-0.7-3.3-1.9c-1.1-1.8-0.6-4.3,1.3-5.4l28.4-17.7c1.3-0.8,2.8-0.8,4.1,0 l12.2,7.4l14.9-12.3c0.7-0.6,1.6-0.9,2.5-0.9h15.9l8.8-16.6c1-1.9,3.4-2.6,5.3-1.6c1.9,1,2.7,3.4,1.6,5.3l-9.9,18.7 c-0.7,1.3-2,2.1-3.5,2.1H201l-15.9,13.2c-1.3,1.1-3.1,1.2-4.5,0.3l-12.6-7.6l-26.4,16.4C141,132.7,140.3,132.9,139.6,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M95.1,242H55c-2.2,0-3.9-1.8-3.9-3.9v-67.8c-1.8,0.9-3.9,1.4-6,1.4c-7.6,0-13.9-6.2-13.9-13.9 v-44.6c0-13.1,10.7-23.8,23.8-23.8h39.5c3.4-1.3,22.4-8.8,41.1-27.4c5-5,13-5.4,18.6-1c5.8,4.5,7.2,11.9,3.6,17.9 c-9.4,15.6-29.6,33.9-58.6,39.6v119.7C99,240.2,97.3,242,95.1,242z M58.9,234.1h32.3v-119c0-1.9,1.4-3.6,3.3-3.9 c28.1-4.5,47.6-21.8,56.4-36.5c1.6-2.7,1-5.7-1.6-7.7c-2.5-2-6.1-1.8-8.2,0.4C119.2,89.4,97.2,96.7,96.3,97 c-0.4,0.1-0.8,0.2-1.2,0.2H55c-8.8,0-15.9,7.1-15.9,15.9v44.6c0,3.3,2.7,6,6,6c3.3,0,6-2.7,6-6c0-2.2,1.8-3.9,3.9-3.9 c2.2,0,3.9,1.8,3.9,3.9V234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M55,161.7c-2.2,0-3.9-1.8-3.9-3.9V124c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v33.7 C58.9,159.9,57.1,161.7,55,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M247.7,154.2h-9.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9h6V57.5c0-2.2,1.8-3.9,3.9-3.9 h7.4V43.4H114.1v10.2h7.4c2.2,0,3.9,1.8,3.9,3.9V71c3.5-2.9,6.9-5.9,10.1-9.1c5-5,13-5.4,18.6-1c5.8,4.5,7.2,11.9,3.6,17.9 c-3.4,5.7-13.2,19.6-32.2,30v37.5h84.2c2.2,0,3.9,1.8,3.9,3.9c0,2.2-1.8,3.9-3.9,3.9h-88.1c-2.2,0-3.9-1.8-3.9-3.9v-43.8 c0-1.5,0.8-2.8,2.1-3.5c19.1-9.8,28.7-24.1,31.2-28.2c1.6-2.7,1-5.7-1.6-7.7c-2.5-2-6.1-1.8-8.2,0.4c-5.3,5.3-11.1,10.2-17.3,14.6 c-1.2,0.9-2.8,1-4.1,0.3c-1.3-0.7-2.1-2-2.1-3.5V61.4h-7.4c-2.2,0-3.9-1.8-3.9-3.9v-18c0-2.2,1.8-3.9,3.9-3.9h148.7 c2.2,0,3.9,1.8,3.9,3.9v18c0,2.2-1.8,3.9-3.9,3.9h-7.4v88.9C251.6,152.5,249.8,154.2,247.7,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M220.9,61.4h-99.4c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9h99.4c2.2,0,3.9,1.8,3.9,3.9 C224.8,59.7,223,61.4,220.9,61.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategie);
export default __webpack_public_path__ + "static/media/stratégie.156ab84b41b33acaa393d946b04703db.svg";
export { ForwardRef as ReactComponent };